import { enumFolderStatus } from "../constants";
import { QAccessFolder } from "./QAccessFolder";
import { sortFolders } from "../utils/sortFolders";

export class QAccessGroup {
  constructor() {
    this.fGroupID = null;
    this.fAllowedViews = null;
    this.fGroupName = null;
    this.fFolderList = null;
    this.fExportExcel = true;
    this.fRowSec = false;
    this.fEditTemplates = true;
    this.fChartAccess = null;
    this.fInteractiveFiltering = true;
  }

  InitAccessGroup() {
    this.fFolderList = [];
  }

  Clone() {
    var u = new QAccessGroup();
    u.InitGroup();

    u.fGroupID = this.fGroupID;
    u.fGroupName = this.fGroupName;
    u.fExportExcel = this.fExportExcel;
    u.fRowSec = this.fRowSec;
    u.fEditTemplates = this.fEditTemplates;
    u.fChartAccess = this.fChartAccess;
    u.fInteractiveFiltering = this.fInteractiveFiltering;

    var n = this.GetFolderCount();
    for (var i = 0; i < n; i++) {
      var theFolder = this.GetIndexFolder(i);
      var newFolder = theFolder.Clone();
      u.fFolderList.push(newFolder);
    }

    return u;
  }

  GetGroupName() {
    return this.fGroupName;
  }

  SetGroupName(groupName) {
    this.fGroupName = groupName;
  }

  GetExportExcel() {
    return this.fExportExcel;
  }

  SetExportExcel(enableExport) {
    this.fExportExcel = enableExport;
  }

  GetRowSec() {
    return this.fRowSec;
  }

  SetRowSec(rowSec) {
    this.fRowSec = rowSec;
  }

  GetEditTemplates() {
    return this.fEditTemplates;
  }

  GetBranchLevelSecurity() {
    return this.fBranchLevelSecurity;
  }

  SetEditTemplates(canEdit) {
    this.fEditTemplates = canEdit;
  }

  GetChartAccess(chartID) {
    //TODO: fix this call to work off chartID
    return this.fChartAccess;
  }

  SetChartAccess(canAccess) {
    return (this.fChartAccess = canAccess);
  }

  SetBranchLevelSecurity(canAccess) {
    //TODO: Fix this call to work off chart ID
    this.fBranchLevelSecurity = canAccess;
  }

  GetGroupID() {
    return this.fGroupID;
  }

  SetGroupID(groupID) {
    this.fGroupID = groupID;
  }

  GetFolderCount() {
    return this.fFolderList.length;
  }

  GetIndexFolder(index) {
    return this.fFolderList[index];
  }

  GetFolderList() {
    return this.fFolderList;
  }

  GetAllowedViewsFromChartID(chartID) {
    if (this.fAllowedViews) return this.fAllowedViews[chartID];
    else return [];
  }

  GetApplicableChartIDs(area) {
    // Chart access could have a different set of chartIDs. Theoretically, it's a super set of chartIDs.
    switch (area) {
      case "allowedViews":
        return this.fAllowedViews != null ? Object.keys(this.fAllowedViews) : [];
    }
  }

  GetFolderNameIndex(folderName) {
    var n = this.GetFolderCount();
    var folderName = folderName.toLowerCase();
    for (var i = 0; i < n; i++) {
      var folder = this.GetIndexFolder(i);
      var curName = folder.GetFolderName();
      if (folderName == curName.toLowerCase()) return i;
    }

    return -1;
  }

  AddFolder(folderName) {
    var folder = new QAccessFolder();
    folder.InitFolder(folderName, false);

    this.fFolderList.push(folder);
    this.fFolderList.sort(sortFolders);
  }

  ToggleFolderLock(folderName) {
    var index = this.GetFolderNameIndex(folderName);
    var folder = this.GetIndexFolder(index);
    folder.ToggleLock();
  }

  RemoveFolder(folderName) {
    var index = this.GetFolderNameIndex(folderName);
    if (index != -1) this.fFolderList.splice(index, 1);
  }

  FolderInGroup(folderName) {
    var n = this.GetFolderCount();
    folderName = folderName.toLowerCase();
    for (var i = 0; i < n; i++) {
      var folder = this.GetIndexFolder(i);
      var curName = folder.GetFolderName();
      if (folderName == curName.toLowerCase()) {
        var isLocked = folder.IsLocked();
        var retVal = enumFolderStatus.ingroup;
        if (isLocked) retVal = enumFolderStatus.ingrouplocked;
        return retVal;
      }
    }

    return enumFolderStatus.notingroup;
  }
}
